import { type RouteRecordRaw } from 'vue-router';

export const publicRoutes: RouteRecordRaw[] = [
    {
        path: "/login",
        name: "login",
        component: () => import("./pages/Login.vue"),
        meta: { guestOnly: true, title: "Login" },
    }
];

export const protectedRoutes: RouteRecordRaw[] = [
    {
        path: "/profile",
        name: "profile",
        component: () => import("./pages/UserDetail.vue"),
        meta: { title: "Perfil" },
    },
    {
        path: "/users",
        name: "users",
        component: () => import("./pages/UserList.vue"),
        meta: { role: 'admin', title: "Usuarios" }
    },
    {
        path: "/users/create",
        name: "users-create",
        component: () => import("./pages/UserForm.vue"),
        meta: { role: 'admin', title: "Crear Usuario" }
    },
    {
        path: "/users/:id",
        name: "users-detail",
        component: () => import("./pages/UserDetail.vue"),
        meta: { title: "Detalle de Usuario" },
    },
    {
        path: "/users/:id/edit",
        name: "users-edit",
        component: () => import("./pages/UserForm.vue"),
        meta: { title: "Editar Usuario" },
    }
];
